import * as React from "react";
const SvgFiRrAnkh = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18 14h-3.557C15.981 11.917 18 8.674 18 6c0-3.309-2.691-6-6-6S6 2.691 6 6c0 2.674 2.02 5.917 3.557 8H6a1 1 0 1 0 0 2h5v7a1 1 0 1 0 2 0v-7h5a1 1 0 1 0 0-2M12 2c2.206 0 4 1.794 4 4 0 2.425-2.446 5.972-4 7.898C10.445 11.974 8 8.43 8 6c0-2.206 1.794-4 4-4"
    />
  </svg>
);
export default SvgFiRrAnkh;
